import * as Permit from '../schemas/inductions/VivaEnergy/supplementalForms/Permit.json'

export default {
    type: 'Viva Energy Supplementals',
    schemas: {
        'WPCG': Permit,
    }
}
